import React, {useState} from 'react';
import {truncate} from 'lodash';
import {onPressEnter} from '../util';
import Stars from './Stars';

const TestimonialCard = ({testimonial, truncateText = true}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div
      className="flex flex-col shadow border border-gray-100 bg-white rounded-xl px-6 py-6 cursor-pointer"
      onClick={handleToggle}
      role="button"
      tabIndex={0}
      onKeyDown={onPressEnter(handleToggle)}
    >
      <div className="flex items-start">
        <img
          className="mr-4 w-12 h-12 rounded-full flex-shrink-0 object-cover"
          src={testimonial.image}
          alt={testimonial.name}
        />
        <div className="flex flex-col justify-center">
          <div className="text-base font-bold">
            {testimonial.name}
          </div>
          <div className="text-sm font-medium text-gray-400">
            {testimonial.title}
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-row mt-4 mb-1 -ml-0.5">
          <Stars />
        </div>
        <div className="text-sm font-regular text-gray-500 leading-relaxed">
          {isExpanded || !truncateText
            ? testimonial.text
            : truncate(testimonial.text, {length: 150, separator: /[.,:;?!]? +/})}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
